import React, {useEffect, useState} from 'react';
import ColorSlider from "./ColorSlider";
import {useDispatch, useSelector} from "react-redux";
import {
    setBlack,
    setBlackURL,
    setImage,
    setIsRed,
    setManipulating,
    setRed,
    setRedURL,
    setStatsLoading,
    setStatsSet
} from "../lib/slices/imageSlice";
import {useDebouncedCallback} from "use-debounce";
// eslint-disable-next-line import/no-webpack-loader-syntax
import setBlackWorker from 'workerize-loader!../workers/setBlack.worker.js';
import Grid from "@mui/material/Grid";
import SliderLockButton from "./SliderLockButton";
import {styled} from "@mui/material/styles";
import Typography from "@mui/material/Typography";


export const variants = {
    RED: 'red',
    GREEN: 'green',
    BLUE: 'blue',
    ALPHA: 'alpha',
};


const StyledLockBox = styled(Grid)(({theme, mobile}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    flexDirection: 'column',
    padding: theme.spacing(2, 0),
    ...(mobile && {
        marginRight: theme.spacing(-2.5),
        marginLeft: theme.spacing(1),
    }),
}));

const StyledTitle = styled(Typography)(({theme}) => ({
    padding: theme.spacing(1, 2),
    textAlign: 'center',
}));

const StyledGrid = styled(Grid)(({theme}) => ({
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
        paddingRight: theme.spacing(2),
    },
}));


export default function ColorSliders() {
    const [mobile,] = React.useState(window.innerWidth < 900);

    // Redux dispatches
    const dispatch = useDispatch();

    // Redux states
    const liveUpdate = useSelector(state => state.app.liveUpdate);
    const currentURL = useSelector(state => state.image.currentURL);
    const thresholds = useSelector(state => state.image.thresholds);
    const originalURL = useSelector(state => state.image.originalURL);
    const manipulating = useSelector(state => state.image.manipulating);

    const [worker, setWorker] = useState(null);

    const handleMessage = (e) => {
        switch (e.data.type) {
            case 'stats': handleReceiveStats(e.data.data); break;
            case 'blackData': handleReceiveBlackImage(e.data.data); break;
            default: break;
        }
    }

    const handleReceiveStats = (data) => {
        dispatch(setBlack(data.black));
        dispatch(setStatsLoading(false));
        dispatch(setStatsSet(true));
    }

    const handleReceiveBlackImage = (data) => {
        dispatch(setImage(data));
        dispatch(setBlackURL(data));
        dispatch(setRedURL(undefined));
    }

    const callManipulate = useDebouncedCallback(() => {
        console.log('Call Manipulate');
        if (currentURL && liveUpdate) {
            console.log('Manipulating image...');
            dispatch(setManipulating(true));
            dispatch(setStatsLoading(true));
            worker.postMessage({
                type: 'setBlackPixels',
                url: originalURL,
                thresholds: thresholds,
            })
            dispatch(setIsRed(false));
        }
    }, 1000);

    // Initialize worker
    useEffect(() => {
        if (!worker) {
            const workerInstance = setBlackWorker();
            workerInstance.addEventListener('message', handleMessage);
            setWorker(workerInstance);
        }
    }, []);

    React.useEffect(() => {
        if (currentURL === originalURL && thresholds.red === 0 && thresholds.green === 0 && thresholds.blue === 0) return;
        callManipulate();
    }, [thresholds.red, thresholds.green, thresholds.blue, callManipulate]);

    const handleRedChange = (color, value) => dispatch(setRed(value));

    return (
        <>
            <StyledTitle variant={'h5'}>Manipulation</StyledTitle>
            <StyledGrid container spacing={0}>
                <Grid item xs={12} lg={11}>
                    <ColorSlider
                        value={thresholds.red}
                        onChange={handleRedChange}
                        disabled={!currentURL}
                    />
                </Grid>
            </StyledGrid>
        </>
    );
}

